module.exports = __webpack_public_path__ + "img/spinner.fd74efd2.svg";